import { render } from "./CompanyLocation.vue?vue&type=template&id=86bd3074"
import script from "./CompanyLocation.vue?vue&type=script&lang=js"
export * from "./CompanyLocation.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__